<template>
  <div class="mobile-wrapper bg-white">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt">
        <div class="row">
          <div
            class="col-12 banner-title"
            :style="proccessing ? 'pointer-events:none' : ''"
          >
            <span class="material-icons md-36" @click="navigateToOrder"
              >keyboard_arrow_left</span
            >
            <span class="title-text" @click="navigateToOrder">Back</span>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <div class="bg-white pt-4 mt-4">
            <div class="pt-4 mt-4 d-flex justify-content-center">
              <div class="w-85 text-center thank-div">
                <br />
                <div class="row">
                  <div class="col-sm-12">
                    <div>
                      <img :src="qrLink" alt="qrLink" />
                    </div>
                    <div v-show="error" class="w-100">
                      <div class="alert alert-danger" role="alert">
                        <strong>{{ error }}</strong>
                      </div>
                    </div>
                    <div v-show="qrLink" class="w-100">
                      <div class="alert-success" role="alert">
                        <strong>{{ $t("message.yourSavedOrder") }}</strong>
                      </div>
                    </div>
                    <span v-show="proccessing">
                      <i class="fa fa-spin fa-spinner" />
                    </span>
                    <div class="row order-history-div">
                      <div class="col-sm-12 text-center">
                        <button
                          type="button"
                          :disabled="proccessing"
                          class="btn btn-info pr-2 btn-with-margins"
                          @click="continueShopping"
                        >
                          {{ $t("message.continueOrdering") }}
                        </button>
                        <div :style="proccessing ? 'pointer-events:none' : ''">
                          <poweredby />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import shared from "../../../sharedscripts/shop/Checkout/Checkout.js";
import poweredby from "../../shared/poweredby";
import QRCode from "qrcode";
export default {
  components: {
    poweredby,
  },
  props: {},
  computed: {
    ...mapGetters(["user", "dbuser", "currentStoreDoc", "cartItems"]),
  },
  mounted() {
    this.store = this.currentStoreDoc;
    this.processSaveOrder();
  },

  data() {
    return {
      proccessing: false,
      qrLink: "",
      error: "",
      store: {},
    };
  },
  methods: {
    ...shared.methods,
    navigateToOrder() {
      if (this.isGift) {
        this.$router.push({
          name: "giftstore",
          params: {
            storeid: this.storeid,
            storename: this.$route.params.storename,
          },
        });
      } else {
        this.$router.push({
          name: "store",
          params: { storeid: this.storeid },
        });
      }
    },
    generateQR(value) {
      QRCode.toDataURL(value)
        .then((url) => {
          sessionStorage.setItem("saveorderUdid", value);
          this.qrLink = url;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    continueShopping() {
      this.$router.push({
        name: "store",
        params: {
          storeid: this.store.ID,
          storename: this.store.Name,
        },
      });
    },
  },
};
</script>
